export default "__VITE_ASSET__lj$_Vd2L__"